/* Blankdays – snabbköp på produktkort (förslag D): ikon → storlekar → varukorg */
(function () {
  var mobile = window.matchMedia('(hover: none), (max-width: 749px)');
  var sheet, sheetSource;

  function closeAll(except) {
    document.querySelectorAll('[data-bd-qs].is-open').forEach(function (el) {
      if (el !== except) { el.classList.remove('is-open'); var t = el.querySelector('[data-bd-qs-toggle]'); if (t) t.setAttribute('aria-expanded', 'false'); }
    });
  }

  function getSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('dialog');
    sheet.className = 'bd-qs-sheet';
    sheet.setAttribute('data-bd-qs', '');
    sheet.setAttribute('tabindex', '-1');
    sheet.innerHTML = '<div class="bd-qs-sheet__head"><div><span class="bd-qs-sheet__title"></span><span class="bd-qs-sheet__price"></span></div>' +
      '<button type="button" class="bd-qs-sheet__close" aria-label="Close"><svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="1.5"/></svg></button></div>' +
      '<span class="bd-qs-sheet__label"></span><div class="bd-qs-sheet__sizes"></div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click', function (e) { if (e.target === sheet || e.target.closest('.bd-qs-sheet__close')) sheet.close(); });
    return sheet;
  }

  function openSheet(card) {
    var s = getSheet(); sheetSource = card;
    s.querySelector('.bd-qs-sheet__title').textContent = card.dataset.title || '';
    s.querySelector('.bd-qs-sheet__price').textContent = card.dataset.price || '';
    if (card.dataset.close) s.querySelector('.bd-qs-sheet__close').setAttribute('aria-label', card.dataset.close);
    var bar = card.querySelector('.bd-qs__bar');
    s.querySelector('.bd-qs-sheet__label').textContent = bar ? bar.getAttribute('aria-label') : '';
    s.querySelector('.bd-qs-sheet__sizes').innerHTML = bar ? bar.innerHTML : '';
    s.showModal();
    s.focus(); /* ingen fokusram på krysset när arket öppnas */
  }

  function showDone(card, size) {
    if (!card) return;
    var done = card.querySelector('.bd-qs__done');
    if (!done) return;
    done.innerHTML = '<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true"><path d="M5 12l5 5 9-10" fill="none" stroke="currentColor" stroke-width="1.5"/></svg><span>' + (size ? size + ' ' : '') + (card.dataset.added || 'added') + '</span>';
    card.classList.remove('is-open'); card.classList.add('is-done');
    setTimeout(function () { card.classList.remove('is-done'); }, 2200);
  }

  function add(btn) {
    var inSheet = !!btn.closest('.bd-qs-sheet');
    var card = inSheet ? sheetSource : btn.closest('[data-bd-qs]');
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(btn.dataset.id), quantity: 1 }] };
    if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    btn.classList.add('is-loading');
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      btn.classList.remove('is-loading');
      if (res.status) { btn.classList.add('is-error'); setTimeout(function () { btn.classList.remove('is-error'); }, 1500); return; }
      if (inSheet && sheet.open) sheet.close();
      showDone(card, btn.dataset.size);
      if (drawer && res.sections) {
        res.id = res.items && res.items[0] ? res.items[0].variant_id : undefined;
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        drawer.renderContents(res);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
    }).catch(function () { btn.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-bd-qs-toggle]');
    if (toggle) {
      e.preventDefault(); e.stopPropagation();
      var card = toggle.closest('[data-bd-qs]');
      if (mobile.matches) { openSheet(card); return; }
      var open = !card.classList.contains('is-open');
      closeAll(card); card.classList.toggle('is-open', open); toggle.setAttribute('aria-expanded', String(open));
      return;
    }
    var btn = e.target.closest('[data-bd-qs] .bd-qs__btn');
    if (btn) { e.preventDefault(); e.stopPropagation(); if (!btn.disabled) add(btn); return; }
    if (!e.target.closest('[data-bd-qs]')) closeAll();
  }, true);

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
})();
